!function (e) {
  var a = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      t = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
  e.languages.soy = {
    comment: [/\/\*[\s\S]*?\*\//, {
      pattern: /(\s)\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    "command-arg": {
      pattern: /({+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
      lookbehind: !0,
      alias: "string",
      inside: {
        punctuation: /\./
      }
    },
    parameter: {
      pattern: /({+\/?\s*@?param\??\s+)\.?[\w.]+/,
      lookbehind: !0,
      alias: "variable"
    },
    keyword: [{
      pattern: /({+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
      lookbehind: !0
    }, /\b(?:any|as|attributes|bool|css|float|in|int|js|html|list|map|null|number|string|uri)\b/],
    delimiter: {
      pattern: /^{+\/?|\/?}+$/,
      alias: "punctuation"
    },
    property: /\w+(?==)/,
    variable: {
      pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+]))*/,
      inside: {
        string: {
          pattern: a,
          greedy: !0
        },
        number: t,
        punctuation: /[\[\].?]/
      }
    },
    string: {
      pattern: a,
      greedy: !0
    },
    "function": [/\w+(?=\()/, {
      pattern: /(\|[^\S\r\n]*)\w+/,
      lookbehind: !0
    }],
    "boolean": /\b(?:true|false)\b/,
    number: t,
    operator: /\?:?|<=?|>=?|==?|!=|[+*\/%-]|\b(?:and|not|or)\b/,
    punctuation: /[{}()\[\]|.,:]/
  }, e.hooks.add("before-tokenize", function (a) {
    var t = /{{.+?}}|{.+?}|\s\/\/.*|\/\*[\s\S]*?\*\//g,
        n = "{literal}",
        l = "{/literal}",
        r = !1;
    e.languages["markup-templating"].buildPlaceholders(a, "soy", t, function (e) {
      return e === l && (r = !1), r ? !1 : (e === n && (r = !0), !0);
    });
  }), e.hooks.add("after-tokenize", function (a) {
    e.languages["markup-templating"].tokenizePlaceholders(a, "soy");
  });
}(Prism);